var render = function () {
  var _vm$currentRound, _vm$currentRound$answ, _vm$currentRound$answ2, _vm$currentRound2, _vm$currentRound2$ans, _vm$currentRound2$ans2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'object-shuffle'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "images-holder focusable",
    class: {
      isMobileView: _vm.isMobile
    },
    attrs: {
      "id": "main-image",
      "tabindex": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$answ = _vm$currentRound.answerImage) === null || _vm$currentRound$answ === void 0 ? void 0 : (_vm$currentRound$answ2 = _vm$currentRound$answ.image) === null || _vm$currentRound$answ2 === void 0 ? void 0 : _vm$currentRound$answ2.src,
      "alt": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$ans = _vm$currentRound2.answerImage) === null || _vm$currentRound2$ans === void 0 ? void 0 : (_vm$currentRound2$ans2 = _vm$currentRound2$ans.image) === null || _vm$currentRound2$ans2 === void 0 ? void 0 : _vm$currentRound2$ans2.description,
      "id": "main-image"
    }
  })])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }